// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1e0lH","signatureBlock":"Footer_signatureBlock__eNvM6","signature":"Footer_signature__y-lI_"};